import {
  getDocs,
  query,
  where,
  collection,
  doc,
  setDoc
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";

export const Save_community = async (data) => {
  const { title, message } = data || {};

  // 1. Validate inputs
  if (!title?.trim()) {
    return { success: false, error: "Missing title." };
  }

  if (!message?.trim()) {
    return { success: false, error: "Missing message." };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || sessiontoken === "undefined") {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid || guid === "undefined") {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {
    const tablename = "community";
    const uid = Randomcode(22);
    const savequery = {
      ...data,
      uid, 
      status: true, 
      guid,
      view:0,
      like:0,
      dislike:0,
      
      sessiontoken,
      date_time: new Date(),
    };

    const docRef = doc(db, tablename, uid);
    await setDoc(docRef, savequery);

    return { success: true };
  } catch (err) {
    console.error("Error saving document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
